export default {
  strict: true,
  namespaced: true,
  state: {
    showLoader: false,
    user: {
      id: null,
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      photoUrl: null,
      access: null,
      accessLoading: false
    },
    sessionToken: null,
    notificationToken: null
  },
  mutations: {
    showLoader (state) { state.showLoader = true },
    hideLoader (state) { state.showLoader = false },
    setUser (state, value) { state.user = value },
    setSessionToken (state, value) { state.sessionToken = value },
    setNotificationToken (state, value) { state.notificationToken = value },
    setAccess (state, value) { state.user.access = value },
    setAccessLoading (state, value) { state.user.accessLoading = value }
  },
  sharedMutations: [
    'session/setUser',
    'session/setAccess',
    'session/setSessionToken'
  ]
}



// WEBPACK FOOTER //
// ./src/store/session.js